import uuid from 'react-uuid';

const proList = [
    {
        id:uuid(),
        title:"Restaurant Homepage",
        desc:"A single page design using HTML & CSS",
        live:"https://italian-res.netlify.app",
        git:"https://github.com/karandas777/Italian-Restaurant",
        date:"June 2019",
        image:require('../assets/proimg/pro1.1.JPG'),
    },
    {
        id:uuid(),
        title:"Business Homepage",
        desc:"A demo homepage using HTML, Bootstrap & Javascript",
        live:"https://zombiz-98.netlify.app/",
        git:"https://github.com/karandas777/Zombiz",
        date:"August 2019",
        image:require('../assets/proimg/pro2.1.JPG'),
    },
    // {
    //     id:uuid(),
    //     title:"Travel Blog",
    //     desc:"A blog application using Anuglar, Express & MongoDB",
    //     live:"",
    //     git:"https://github.com/karandas777/Explore-India",
    //     date:"October 2019",
    //     image:require('../assets/proimg/pro3.1.JPG'),
    // },
    // {
    //     id:uuid(),
    //     title:"GYM Mgmt. System",
    //     desc:"A Gym Management application using Anuglar, Express & MongoDB",
    //     live:"",
    //     git:"https://github.com/karandas777/CardioClub",
    //     date:"December 2019",
    //     image:require('../assets/proimg/pro4.1.JPG'),
    // },
    {
        id:uuid(),
        title:"IMDB Replica",
        desc:"Replica of popular movie review site IMDB, using ReactJS & MoviesDB API",
        live:"https://imdb2020.netlify.app/",
        git:"https://github.com/karandas777/imdb",
        date:"February 2020",
        image:require('../assets/proimg/pro5.1.JPG'),
    },
    {
        id:uuid(),
        title:"Dogs Gallery",
        desc:"Explore various breeds and a wide range of images, using ReactJS & Dogs API",
        live:"https://doggstagram.netlify.app/",
        git:"https://github.com/karandas777/doggy",
        date:"May 2020",
        image:require('../assets/proimg/pro6.1.JPG'),
    },
    // {
    //     id:uuid(),
    //     title:"News Application",
    //     desc:"A multi source news application created using ReactJS & News API",
    //     live:"",
    //     git:"https://github.com/karandas777/NEWS-United",
    //     date:"May 2020",
    //     image:require('../assets/proimg/pro7.1.JPG'),
    // },
    // {
    //     id:uuid(),
    //     title:"Currency Exchange Rate",
    //     desc:"An application that lists the exchange rates of various currency across the world",
    //     live:"https://ratesnow.netlify.app/",
    //     git:"https://github.com/karandas777/rates",
    //     date:"June 2020",
    //     image:require('../assets/proimg/pro8.1.JPG'),
    // },
    // {
    //     id:uuid(),
    //     title:"Timeline",
    //     desc:"A simple blog application created using ReactJS, Express, MongoDB & Firebase.",
    //     live:"https://time-line.netlify.app/",
    //     git:"https://github.com/karandas777/timeline",
    //     date:"July 2020",
    //     image:require('../assets/proimg/pro9.1.JPG'),
    // },
    {
        id:uuid(),
        title:"Realtime Chatroom",
        desc:"A global chatroom created using ReactJS & Firebase Realtime DB",
        live:"https://chatbuddy.netlify.app/",
        git:"https://github.com/karandas777/Chatroom",
        date:"July 2020",
        image:require('../assets/proimg/pro10.1.JPG'),
    },
    // {
    //     id:uuid(),
    //     title:"PapersPro",
    //     desc:"A wallpaper download site created using ReactJS & Firebase Database/Storage",
    //     live:"https://paperspro.netlify.app/",
    //     git:"https://github.com/karandas777/papers",
    //     date:"July 2020",
    //     image:require('../assets/proimg/pro11.1.JPG'),
    // },
    {
        id:uuid(),
        title:"To-Do List",
        desc:"A to-do list application created using ReactJS",
        live:"https://w-todo.netlify.app/",
        git:"https://github.com/karandas777/To-Do",
        date:"August 2020",
        image:require('../assets/proimg/pro12.1.JPG'),
    },
    {
        id:uuid(),
        title:"Budget Calculator",
        desc:"A budget calculator application created using ReactJS",
        live:"https://whats-my-budget.netlify.app/",
        git:"https://github.com/karandas777/Budget",
        date:"August 2020",
        image:require('../assets/proimg/pro13.1.JPG'),
    },
    // {
    //     id:uuid(),
    //     title:"InstaPRO",
    //     desc:"A replica of Instagram created using ReactJS, ExpressJS & Firebase",
    //     live:"https://instapro.netlify.app/",
    //     git:"https://github.com/karandas777/instapro",
    //     date:"30th August 2020",
    //     image:require('../assets/proimg/pro14.1.JPG'),
    // },
    {
        id:uuid(),
        title:"Weather App",
        desc:"A weather app created using ReactJS & Open Weather API",
        live:"https://dark-sky.netlify.app/",
        git:"https://github.com/karandas777/weather",
        date:"August 2020",
        image:require('../assets/proimg/pro15.1.JPG'),
    },
    {
        id:uuid(),
        title:"Youtube Replica",
        desc:"Youtube replica using ReactJS",
        live:"https://yt-lite.netlify.app/",
        git:"https://github.com/karandas777/yt-lite",
        date:"September 2020",
        image:require('../assets/proimg/pro16.1.JPG'),
    },
    {
        id:uuid(),
        title:"Recipe App",
        desc:"A recipe finder app created using ReactJS & EDAMAM Recipe API",
        live:"https://recipemaster.netlify.app/",
        git:"https://github.com/karandas777/recipe",
        date:"October 2020",
        image:require('../assets/proimg/pro17.1.JPG')
    },
    {
        id:uuid(),
        title:"Unsplash Replica",
        desc:"Unsplash replica using ReactJS & Unsplash API",
        live:"https://imagenary.netlify.app/",
        git:"https://github.com/karandas777/imagenary",
        date:"22nd October 2020",
        image:require('../assets/proimg/pro18.1.JPG'),
    },
    {
        id:uuid(),
        title:"ITC myClassmate App",
        desc:"Developed the backend of the application using NodeJS, ExpressJS & MongoDB",
        live:"https://play.google.com/store/apps/details?id=com.XYZ.ITCClassMate",
        date:"November 2021",
        image:require('../assets/proimg/itc.JPG'),
    },
    {
        id:uuid(),
        title:"Techved Consulting Website",
        desc:"Developed new pages using HTML, CSS & Javascript",
        live:"https://www.techved.com/",
        date:"January 2021",
        image:require('../assets/proimg/tvd.JPG'),
    },
    {
        id:uuid(),
        title:"Kotak General Insurance Website",
        desc:"Developed the whole UI of the website using ReactJS and integrated APIs for functionality",
        live:"https://www.kotakgeneral.com/",
        date:"June 2022",
        image:require('../assets/proimg/kgi.JPG'),
    },

    
]

export default proList.reverse();